// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__rYuYe","title":"ClientInsurance_title__10fXD","itemText":"ClientInsurance_itemText__3QC8v"};